// extracted by mini-css-extract-plugin
export default {"delete":"DeleteButton_delete__y7vhP"};